module.exports = __webpack_public_path__ + "static/0003-1596f14f86a286614e1b5314fbf5307b.png";